import * as React from "react";

const fields = (t) => {return {
    config: {columns: 2},
    fields: [
        {
            name: "id",
            label: t ? t("common.id") : "ID",
            readOnly: true,
            column: 1
        },
        {
            name: "name",
            label: t ? t("common.name") : "Nazwa",
            column: 1,
        },
        {
            name: "internalNumber",
            label: t ? t("common.internal_number") : "Numer wewnętrzny",
            column: 1,
        },
        {
            name: "packingSystem",
            label: t ? t("common.packing_system") : "System pakowania",
            type: "enum",
            enumType: "enums/packingSystem",
            column: 2,
        },
        {
            name: "room",
            label: t ? t("common.room") : "Pomieszczenie",
            column: 1,
        },
    ]


}};

export default fields;